var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 441,
    height: 403,
    viewBox: "0 0 441 403",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6602 66.334H32.5009V86.1747L20.8299 74.5037L12.6602 66.334Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3855 138.933C92.305 148.228 81.664 154.28 69.72 154.28C50.8268 154.28 35.4082 138.933 35.4082 120.127C35.4082 101.322 50.8268 85.9746 69.72 85.9746C81.664 85.9746 92.305 92.027 98.3855 101.322",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3855 138.933C92.305 148.228 81.664 154.28 69.72 154.28C50.8268 154.28 35.4082 138.933 35.4082 120.127C35.4082 101.322 50.8268 85.9746 69.72 85.9746C81.664 85.9746 92.305 92.027 98.3855 101.322",
    stroke: "currentColor",
    strokeWidth: 5.87099,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4004 106.511C81.0116 104.566 77.537 103.701 73.4109 103.701H60.3811V128.343H55.6035V130.937V132.882H60.3811V136.557H65.1587V132.882H75.3654V130.937V128.343H65.1587V125.533H73.4109C77.7542 125.533 81.0116 124.668 83.4004 122.723C85.7892 120.778 87.0922 118.184 87.0922 114.509C87.0922 111.051 85.7892 108.457 83.4004 106.511ZM79.9258 119.913C78.4057 121.21 76.234 121.858 73.1937 121.858H64.9415V107.808H73.4109C76.234 107.808 78.6228 108.457 80.143 109.537C81.6631 110.834 82.5318 112.347 82.5318 114.725C82.3146 116.887 81.4459 118.616 79.9258 119.913Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7229 149.092C85.7943 149.092 98.8228 136.124 98.8228 120.127C98.8228 104.13 85.7943 91.1621 69.7229 91.1621C53.6515 91.1621 40.623 104.13 40.623 120.127C40.623 136.124 53.6515 149.092 69.7229 149.092Z",
    stroke: "currentColor",
    strokeWidth: 2.20162,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M298.487 400.142H123.98C109.718 400.142 98.252 388.729 98.252 374.533V56.3653V29.0858C98.252 14.8894 109.718 3.47656 123.98 3.47656H298.487C312.749 3.47656 324.215 14.8894 324.215 29.0858V374.533C324.215 388.451 312.749 400.142 298.487 400.142Z",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 5.57067,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.985 384.27C118.672 384.27 114.197 379.816 114.197 374.527V29.0806C114.197 23.7917 118.672 19.3379 123.985 19.3379H298.491C303.805 19.3379 308.279 23.7917 308.279 29.0806V374.527C308.279 379.816 303.805 384.27 298.491 384.27H123.985Z",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 2.09091,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.983 376.479C122.864 376.479 122.025 375.644 122.025 374.53V29.0833C122.025 27.9699 122.864 27.1348 123.983 27.1348H298.489C299.608 27.1348 300.447 27.9699 300.447 29.0833V374.53C300.447 375.644 299.608 376.479 298.489 376.479H123.983Z",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 2.09091,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.252 56.3594H324.215",
    stroke: "currentColor",
    strokeWidth: 5.57067,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M98.252 345.023H324.215",
    stroke: "currentColor",
    strokeWidth: 7.5605,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M189.146 365.621H233.332",
    stroke: "currentColor",
    strokeWidth: 7.5605,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M389.328 232.074H372.84V294.075H389.328V232.074Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M360.325 259.273H343.736V295.967H360.325V259.273Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M195.013 200.272C203.044 200.272 209.555 193.791 209.555 185.797C209.555 177.803 203.044 171.322 195.013 171.322C186.981 171.322 180.471 177.803 180.471 185.797C180.471 193.791 186.981 200.272 195.013 200.272Z",
    stroke: "currentColor",
    strokeWidth: 7.5605,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M195.016 192.209C198.568 192.209 201.448 189.343 201.448 185.807C201.448 182.271 198.568 179.404 195.016 179.404C191.464 179.404 188.584 182.271 188.584 185.807C188.584 189.343 191.464 192.209 195.016 192.209Z",
    stroke: "currentColor",
    strokeWidth: 2.83519,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M229.413 246.766C237.445 246.766 243.955 240.285 243.955 232.291C243.955 224.297 237.445 217.816 229.413 217.816C221.382 217.816 214.871 224.297 214.871 232.291C214.871 240.285 221.382 246.766 229.413 246.766Z",
    stroke: "currentColor",
    strokeWidth: 7.5605,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M229.413 238.691C232.965 238.691 235.845 235.825 235.845 232.289C235.845 228.753 232.965 225.887 229.413 225.887C225.86 225.887 222.98 228.753 222.98 232.289C222.98 235.825 225.86 238.691 229.413 238.691Z",
    stroke: "currentColor",
    strokeWidth: 2.83519,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M241.158 179.404L174.879 245.098",
    stroke: "currentColor",
    strokeWidth: 7.5605,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M287.302 210.3C287.302 216.703 279.751 222.27 278.073 228.115C276.395 234.239 280.31 242.869 277.234 248.158C274.158 253.725 264.649 254.56 260.175 259.014C255.7 263.467 254.861 272.653 249.268 275.994C243.955 279.056 235.285 275.159 229.133 276.829C223.26 278.499 217.667 286.015 211.235 286.015C204.803 286.015 199.209 278.499 193.337 276.829C187.184 275.159 178.515 279.056 173.201 275.994C167.608 272.932 166.769 263.467 162.295 259.014C157.82 254.56 148.592 253.725 145.236 248.158C142.159 242.869 146.075 234.239 144.397 228.115C142.719 222.27 135.168 216.703 135.168 210.3C135.168 203.898 142.719 198.331 144.397 192.485C146.075 186.361 142.159 177.732 145.236 172.443C148.312 166.876 157.82 166.041 162.295 161.587C166.769 157.133 167.608 147.947 173.201 144.607C178.515 141.545 187.184 145.442 193.337 143.772C199.209 142.102 204.803 134.586 211.235 134.586C217.667 134.586 223.26 142.102 229.133 143.772C235.285 145.442 243.955 141.545 249.268 144.607C254.861 147.669 255.7 157.133 260.175 161.587C264.649 166.041 273.878 166.876 277.234 172.443C280.31 177.732 276.395 186.361 278.073 192.485C279.751 198.609 287.302 203.898 287.302 210.3Z",
    stroke: "currentColor",
    strokeWidth: 7.5605,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M211.24 278.223C205.368 278.223 200.613 270.708 195.3 269.316C189.707 267.924 181.876 271.821 177.122 269.037C172.088 266.254 171.809 257.346 167.893 253.449C163.978 249.552 155.029 249.274 152.233 244.263C149.436 239.531 153.631 231.737 151.953 226.17C150.555 220.881 143.004 216.149 143.004 210.303C143.004 204.458 150.555 199.725 151.953 194.436C153.351 188.869 149.436 181.075 152.233 176.343C155.029 171.332 163.978 171.054 167.893 167.157C171.809 163.26 172.088 154.352 177.122 151.569C181.876 148.785 189.707 152.961 195.3 151.29C200.613 149.899 205.368 142.383 211.24 142.383C217.113 142.383 221.867 149.899 227.181 151.29C232.774 152.682 240.604 148.785 245.359 151.569C250.392 154.352 250.672 163.26 254.587 167.157C258.502 171.054 267.451 171.332 270.248 176.343C273.045 181.075 268.85 188.869 270.528 194.436C271.926 199.725 279.477 204.458 279.477 210.303C279.477 216.149 271.926 220.881 270.528 226.17C269.129 231.737 273.045 239.531 270.248 244.263C267.451 249.274 258.502 249.552 254.587 253.449C250.672 257.346 250.392 266.254 245.359 269.037C240.604 271.821 232.774 267.646 227.181 269.316C221.867 270.708 217.113 278.223 211.24 278.223Z",
    stroke: "currentColor",
    strokeWidth: 2.83519,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6419 188.218C67.5456 189.515 76.4493 188.867 85.1358 186.489C85.7873 186.273 86.4388 185.624 86.656 184.976C86.8732 184.327 86.656 183.463 86.0045 182.814C85.353 182.166 84.7015 182.166 83.8329 182.166C75.5807 184.327 67.3285 184.76 58.8591 183.679C42.1375 181.517 27.1532 172.655 16.9466 159.253C6.7399 145.851 2.17947 129.207 4.56827 112.563C6.30557 99.8099 11.7347 87.9212 20.6384 78.4103L21.0727 77.978L31.9308 88.3535C32.5823 89.002 33.451 89.2182 34.3196 88.7859C35.1883 88.3535 35.6226 87.7051 35.6226 86.8404L35.8398 65.4409C35.8398 64.7924 35.6226 64.3601 35.1883 63.9278C34.754 63.4955 34.1025 63.2793 33.6682 63.2793L12.3861 64.1439C11.5175 64.1439 10.6488 64.7924 10.4317 65.4409C10.2145 66.0893 10.4317 67.1701 10.866 67.8186L18.2496 74.9518L17.8152 75.3841C8.4772 85.5435 2.39663 98.2968 0.659327 111.915C-4.55259 149.094 21.7242 183.247 58.6419 188.218ZM31.4965 68.2509V82.3011L17.5981 68.8994L31.4965 68.2509Z",
    fill: "currentColor"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M357.283 293.202H345.727V261.39C345.727 260.671 346.268 260.132 346.991 260.132H356.019C356.741 260.132 357.283 260.671 357.283 261.39V293.202ZM386.354 293.202H374.798V235.15C374.798 234.431 375.339 233.891 376.062 233.891H385.09C385.812 233.891 386.354 234.431 386.354 235.15V293.202ZM322.795 294.1V296.796H394.118C395.201 296.796 395.924 295.898 395.924 294.999C395.924 293.921 395.201 293.202 394.118 293.202H390.146V235.15C390.146 232.454 387.979 230.297 385.27 230.297H376.242C373.534 230.297 371.367 232.454 371.367 235.15V293.202H361.075V261.39C361.075 258.694 358.908 256.537 356.199 256.537H347.171C344.463 256.537 342.296 258.694 342.296 261.39V293.202H332.184V276.667C332.184 273.971 330.017 271.814 327.309 271.814H322.975V275.409H327.309C328.031 275.409 328.573 275.948 328.573 276.667V293.202H325.503H322.614H319.184L322.795 294.1Z",
    fill: "currentColor"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M389.964 205.315C389.964 204.776 389.784 204.237 389.422 203.877C389.061 203.518 388.52 203.338 387.978 203.338H376.964C375.88 203.338 375.158 204.237 375.158 205.135C375.158 206.214 376.061 206.932 376.964 206.932H383.825L365.768 224.905L358.907 218.076C358.546 217.716 358.185 217.536 357.643 217.536C357.101 217.536 356.74 217.716 356.379 218.076L323.516 250.786C322.794 251.505 322.794 252.583 323.516 253.302C323.877 253.662 324.419 253.842 324.78 253.842C325.322 253.842 325.683 253.662 326.044 253.302L357.643 221.85L364.505 228.68C365.227 229.399 366.31 229.399 367.032 228.68L386.533 209.269V215.38C386.533 216.458 387.436 217.177 388.339 217.177C389.242 217.177 390.145 216.278 390.145 215.38L389.964 205.315Z",
    fill: "currentColor"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M354.572 263.545H348.252V294.099H354.572V263.545Z",
    stroke: "currentColor",
    strokeWidth: 1.83058,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M322.797 278.822H325.505V293.201V294.099H322.797",
    stroke: "currentColor",
    strokeWidth: 1.83058,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M383.826 237.482H377.506V294.097H383.826V237.482Z",
    stroke: "currentColor",
    strokeWidth: 1.83058,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialSupport);
export default __webpack_public_path__ + "static/media/socialSupport.520dd7b6.svg";
export { ForwardRef as ReactComponent };